<template>
  <div style="height: 100%">
    <v-card style="height: 100%">
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12" align="center">
            <h1>Revenue</h1>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="6" sm="4" align="center">
            <h2>Revenue YTD:<br>{{ revenueTileData.revenue | currency }}</h2>
          </v-col>
          <v-col cols="6" sm="4" align="center">
            <h2>Year Goal:<br>{{ revenueTileData.yearGoal | currency }}</h2>
          </v-col>
          <v-col cols="6" sm="4" align="center">
            <h2>% to Plan:<br>{{ revenueTileData.percentageToPlan | percent }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <v-btn
              text
              color="primary"
              :disabled="disableButtons"
              @click="showRevenueDetails"
            >
              Details
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="end">
            <v-btn
              v-if="!showFetchingDataGIF"
              color="primary"
              outlined
              class="ml-2"
              @click="refreshTile"
              style="float: left;"
              >
                <v-icon>refresh</v-icon>
            </v-btn>
            <i
              v-if="showFetchingDataGIF"
              class="mr-2"
            >
              Fetching Data
            </i>
            <v-progress-circular
              v-if="showFetchingDataGIF"
              :size="30"
              :width="7"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <i
              v-if="lastRefreshTime"
              class="ml-10 mr-5"
            >
              Last Update: {{ lastRefreshTime }}
            </i>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <RevenueDetails
      ref="RevenueDetailsModal"
    ></RevenueDetails>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { isJSONString } from '@/lib/miscellaneous'
import { getLocalTimeString } from '@/lib/display'
import RevenueDetails from './RevenueDetails'

export default {
  components: {
    RevenueDetails
  },
  data () {
    return {
      filterYear: new Date().getFullYear(),
      revenueLogItems: [],
      goalData: {
        year: new Date().getFullYear(),
        goal: null
      },
      expectedRevenue: 0,
      revenueTileData: {
        revenue: null,
        monthGoal: null,
        yearGoal: null,
        percentageToPlan: null
      },
      lastRefreshTime: null,
      showFetchingDataGIF: false,
      disableButtons: false,
      showRevenueDetailsModal: false
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getRevenueData'
    ]),
    refreshTile () {
      this.showFetchingDataGIF = true
      this.disableButtons = true
      this.getRevenueData().then((data) => {
        if (data) {
          this.setRevenueData(data)
          let dateTimeNow = new Date()
          localStorage.setItem('dashboard:revenue-data', JSON.stringify(data))
          localStorage.setItem('dashboard:revenue-data-last-refresh-time', JSON.stringify(dateTimeNow.toUTCString()))
          this.lastRefreshTime = getLocalTimeString(dateTimeNow)
        }
        this.showFetchingDataGIF = false
        this.disableButtons = false
      })
    },
    setRevenueData (data) {
      let currentMonth = new Date().getMonth() + 1
      this.filterYear = data.year
      this.revenueLogItems = data.revenueLogItems
      this.goalData = data.goalData
      // Get the revenue
      if (data.revenueLogItems && data.revenueLogItems.length > 0) {
        let itemsToCompute = data.revenueLogItems.filter(item => item.month < currentMonth)
        this.revenueTileData.revenue = itemsToCompute.reduce((acc, row) => {
          acc += row.revenue
          return acc
        }, 0)
      } else {
        this.revenueTileData.revenue = 0
      }
      // Get the month goal
      this.revenueTileData.monthGoal = data.goalData.goal / 12
      // Set the year goal
      this.revenueTileData.yearGoal = data.goalData.goal
      // Get the expected revenue according to current month
      this.expectedRevenue = currentMonth === 1 ? null : this.revenueTileData.monthGoal * (currentMonth - 1)
      // Get the percentage to plan
      this.revenueTileData.percentageToPlan = this.expectedRevenue ? (this.revenueTileData.revenue / this.expectedRevenue) * 100 : null
    },
    showRevenueDetails () {
      this.$refs.RevenueDetailsModal.showModal()
    }
  },
  created () {
    if (localStorage.getItem('dashboard:revenue-data') && isJSONString(localStorage.getItem('dashboard:revenue-data'))) {
      this.setRevenueData(JSON.parse(localStorage.getItem('dashboard:revenue-data')))
    }
    if (localStorage.getItem('dashboard:revenue-data-last-refresh-time') && isJSONString(localStorage.getItem('dashboard:revenue-data-last-refresh-time'))) {
      let lastRefreshTime = new Date(JSON.parse(localStorage.getItem('dashboard:revenue-data-last-refresh-time')))
      this.lastRefreshTime = getLocalTimeString(lastRefreshTime)
    }
    this.refreshTile()
  }
}
</script>
